import { h, render } from 'preact';
import ShopTheLook from './shop-the-look';
import ShopTheLookVb from './shop-the-look-vb';

export default (element, data) => {
  const renderComponent = () => {
    if(data.templateName === 'product'){
      render(<div className=''>
      <ShopTheLook {...data} />
      <ShopTheLookVb {...data} />
      </div>
       , element);
    }else{
      render(<div className=''>
      <ShopTheLook {...data} />
      </div>
       , element);
    }
    
  };

  const init = () => {
    renderComponent();
  };

  init();
};
